import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
  selector: "icon",
  templateUrl: "./icon.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "tw-flex tw-justify-center tw-items-center",
  },
})
export class IconComponent {
  @Input() name: string;
  @Input() size: number;
  @Input() sizeArbitrary: string;
  @Input() currentColor: string;
  @Input() disableArrowOverride: boolean = false;

  getSize(): string {
    if (this.size) {
      return `tw-w-${this.size} tw-h-${this.size}`;
    } else {
      return `tw-w-[${this.sizeArbitrary}] tw-h-[${this.sizeArbitrary}]`;
    }
  }

  getColorClass(): string {
    if (!this.disableArrowOverride && this.name && this.name.toLowerCase().includes("arrow")) {
      return "tw-text-dt-text-secondary";
    }
    // No explicit color → inherit from the parent (the original behaviour).
    return this.currentColor ? `tw-text-${this.currentColor}` : "";
  }
}
